<template>
  <fragment>
    <div class="col-12">
      <div class="dash-section">
        <div class="header">
          <div class="table-filters section-header-offset">
            <metric-buttons
              class="dash-button-group"
              :timeframe="listShowing"
              :filtered="listFilter"
              :disabled="reportsFetching"
              @filter="setListFilter"
            />
            <custom-tags-input class="tags" :value="customCampusTags" @input="setCustomTags" />
            <header-buttons class="dash-button-group"
                            :from="from"
                            :through="through"
                            :disabled="reportsFetching"
                            @change="update"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-7">
      <div class="dash-section dash-sub-section contains-list">
        <metrics
          :timeframe="listShowing"
          :filtered="listFilter"
          :disabled="reportsFetching"
          @filter="setListFilter"
        />
        <list-title
          :timeframe="listShowing"
          :filtered="listFilter"
        />
        <list :mobile="$globals.isMobile" />
        <div v-if="$globals.isMobile && hasNext && !sessionsReport.loading" class="load-more">
          <button class="dash-button" @click="handleLoadMore">
            Load More Results
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-5">
      <div class="dash-section">
        <div class="header">
          <div>
            <h2 id="sectionTitle" class="title">
              Session Distribution
              {{ (listFilter === 'canceled' ? '- Cancels'
                : listFilter === 'successful' ? '- Successes'
                  : listFilter === 'not attended' ? '- No Shows'
                    : '')
              }}
            </h2>
          </div>
        </div>
        <distribution-chart :filtered="listFilter" />
      </div>
    </div>
  </fragment>
</template>

<script>
import List from './components/List.vue';
import ListTitle from './components/ListTitle.vue'
import Metrics from './components/Metrics.vue';
import Skeleton from '../../Skeleton.vue';
import HeaderButtons from './components/HeaderButtons.vue';
import DistributionChart from './components/DistributionChart.vue';
import CustomTagsInput from '../../CustomTagsInput.vue';
import MetricButtons from './components/MetricButtons.vue';


export default {
  name: 'SessionsTab',

  components: {
    List,
    ListTitle,
    Metrics,
    Skeleton,
    HeaderButtons,
    DistributionChart,
    CustomTagsInput,
    MetricButtons
  },

  inject: [
    'sessionsMetricsReport',
    'sessionsReport',
    'uniqueStudents',
    'uniqueCounselors',
    'outOfPocketStudents',
    'customUserTags'
  ],

  data() {
    return {
      from: null,
      through: null,
      listShowing: 'recent',
      listFilter: 'all',
      customCampusTags: []
    };
  },

  computed: {
    hasNext() {
      return this.sessionsReport.hasNext;
    },
    reportsFetching() {
      return this.sessionsMetricsReport.loading
        || this.sessionsReport.loading
        || this.uniqueStudents.loading
        || this.uniqueCounselors.loading
        || this.outOfPocketStudents.loading;
    }
  },

  created() {
    window.addEventListener('scroll', this.handleScroll, { once:true });
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, { once:true });
  },

  mounted() {
    // HeaderButtons emits inital state
  },

  methods: {
    async handleScroll() {
      if (!this || !this.sessionsReport || this.sessionsReport.loading) {
        return;
      }

      const atBottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >=
        document.documentElement.offsetHeight * 0.8;
      if (!this.$globals.isMobile && atBottomOfWindow && this.hasNext && !this.reportsFetching) {
        await this.sessionsReport.fetch();
      }
      window.addEventListener('scroll', this.handleScroll, { once:true });
    },

    handleLoadMore() {
      this.sessionsReport.fetch();
    },

    update({ selected, from, through }) {
      this.listShowing = selected;
      this.listFilter = 'all';

      this.sessionsReport
        .asAllStatuses()
        .from(from)
        .through(through)
        .fetch();
      this.sessionsMetricsReport
        .asAllStatuses()
        .from(from)
        .through(through)
        .fetch();
      this.outOfPocketStudents
        .asAllStatuses()
        .asPaidOutOfPocket()
        .from(from)
        .through(through)
        .fetch();
      this.uniqueStudents
        .asSuccessStatus()
        .from(from)
        .through(through)
        .fetch();
      this.uniqueCounselors
        .asSuccessStatus()
        .from(from)
        .through(through)
        .fetch();

      this.from = from ? this.sessionsReport.parameters.from.format('YYYY-MM-DD') : null;
      this.through = through ? this.sessionsReport.parameters.through.format('YYYY-MM-DD') : null;
    },

    setListFilter(filter) {
      this.listFilter = filter;

      switch (filter) {
        case 'all':
          this.sessionsReport.asAllStatuses().fetch();
          this.uniqueStudents.asAllStatuses().fetch();
          this.outOfPocketStudents.asAllStatuses().fetch();
          break;
        case 'successful':
          this.sessionsReport.asSuccessStatuses().fetch();
          this.uniqueStudents.asSuccessStatus().fetch();
          this.outOfPocketStudents.asSuccessStatus().fetch();
          break;
        case 'canceled':
          this.sessionsReport.asCanceledStatuses().fetch();
          this.uniqueStudents.asCanceledStatus().fetch();
          this.uniqueCounselors.asCanceledStatus().fetch();
          break;
        case 'not attended':
          this.sessionsReport.asNotAttendedStatuses().fetch();
          this.uniqueStudents.asAbsentStatus().fetch();
          this.uniqueCounselors.asAbsentStatus().fetch();
          break;
        default:
          throw new Error();
      }
    },
    setCustomTags(tagsList) {
      this.customCampusTags = tagsList;
      this.sessionsReport
        .withCustomTags(tagsList)
        .fetch();
      this.sessionsMetricsReport
        .withCustomTags(tagsList)
        .fetch();
      this.outOfPocketStudents
        .withCustomTags(tagsList)
        .fetch();
      this.uniqueStudents
        .withCustomTags(tagsList)
        .fetch();
      this.uniqueCounselors
        .withCustomTags(tagsList)
        .fetch();
    }
  }
};
</script>
<style lang="scss" scoped>

.header.list {
  border-top: 1px solid #e0e0e0;
}

.dash-section {
  min-height: 0px;
.table-filters {
      width: 100%;
      display: flex;
      flex-flow: row wrap;
      gap: 1rem;
      justify-content: space-between;
      @media screen and (min-width: 1200px) {
      .tags {
        justify-self: end;
        margin-left: auto;
      }
    }

    }
  }
</style>
